const errorMessages = {
    generalError: 'Something went wrong.\nPlease try again or contact our support team at support@iloverbs.com',
    SOMETHING_WRONG: 'Something went wrong.\nPlease try again or contact our support team at support@iloverbs.com',
    NETWORK_ERROR: 'NETWORK ERROR',
  };
  
  export default errorMessages;
  